import Page from "@/lib/components/Page";
import {Color} from "@/lib/styles";
import ActionButton from "@/lib/components/ActionButton";

export default function DebugScreen() {
    function dummy() {

    }

    return (
        <Page scrollable={true}>
            <ActionButton color={Color.Green} title={"Grønn"} onPress={dummy}/>
            <ActionButton color={Color.Yellow} busy={true} title={"Gul opptatt"} onPress={dummy}/>
            <ActionButton disabled={true} title={"Avslått"} onPress={dummy}/>
            <ActionButton backgroundColor={Color.Red} title={"Farge"} onPress={dummy}/>
            <ActionButton icon={"participants"} title={"Ikon"} onPress={dummy}/>
        </Page>
    )
}